export default __webpack_public_path__ + "static/media/background.a5b27c9a.png";